export default __webpack_public_path__ + "bddc9a6f6096fa3ef14a82e09f0c957d.png";